export default __webpack_public_path__ + "static/media/TravelFeed.8af4e8ed.jpeg";